import {IPsoWorkAgreementsViewModel} from "./pso-works-agreements.view-model.interface";
import {Lazy} from "../../../../../../utils/lazy";
import {PsoWorkerAgreementModel} from "./pso-worker-agreement.model";
import {PsoUserOptionsEnum} from "../../../../../flight-search/flight-search-controller/pso.enums";
import {BookingSessionStorageKeys} from "../../../storage/booking-session-storage-keys";
import {
    IDownloadPsoWorkerDeclarationRequest, PsoDeclarationJourneyDetailsRequest
} from "../../../../../airline-webapi/requests/download-pso-declaration.request";
import {PsoAgreementsModel} from "../base/pso-agreements.model";
import {IPsoWorkerAgreementFormFields} from "./pso-worker-agreement.view-model.interface";
import {AirlineWebapiResponse} from "../../../../../airline-webapi/airline-webapi-response";
import {IDownloadBlobResponse} from "../../../../../airline-webapi/responses/download-blob.response";

export class PsoWorkersAgreementsModel extends PsoAgreementsModel<IPsoWorkerAgreementFormFields, PsoWorkerAgreementModel>
    implements IPsoWorkAgreementsViewModel {

    get confirmedStorageKey(): BookingSessionStorageKeys {
        return BookingSessionStorageKeys.psoWorkersAgreementAccepted;
    }
    get downloadedStorageKey(): BookingSessionStorageKeys {
        return BookingSessionStorageKeys.psoWorkersAgreementDownloaded;
    }
    get submittedStorageKey(): BookingSessionStorageKeys {
        return BookingSessionStorageKeys.psoWorkersAgreementSubmitted;
    }

    private readonly _workers: Lazy<PsoWorkerAgreementModel[]> = new Lazy<PsoWorkerAgreementModel[]>(() => {
        return this.booking.passengers.filter(p => p.passengerType.isAdult)
            .map(p => new PsoWorkerAgreementModel(p));
    });


    protected getAgreements(): PsoWorkerAgreementModel[] {
        if(this.booking.bookingStrategyAdapter.flightSearchController.psoUserOption === PsoUserOptionsEnum.Worker) {
            return this._workers.value;
        }

        return [];
    }

    protected async downloadSpecificDeclaration(journeyDetails: PsoDeclarationJourneyDetailsRequest): Promise<AirlineWebapiResponse<IDownloadBlobResponse>> {
        const request: IDownloadPsoWorkerDeclarationRequest = {
            language: this.services.language.currentLanguage,
            JourneyDetails: journeyDetails,
            agreements: this.agreements.map(w => w.buildApiRequest())
        }

        return await this.services.airlineWebapi.downloadPsoWorkersDeclaration(request);
    }



}